module.exports = __webpack_public_path__ + "static/media/ropaHombre.05681528.png";